import React, { useEffect, useRef } from "react";

export const StarFormation = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resizeCanvas = () => {
      const parent = canvas.parentNode;
      const width = parent.offsetWidth; // Use offsetWidth for better Safari compatibility
      const height = parent.offsetHeight;

      canvas.width = width;
      canvas.height = height;

      drawBackground(); // Redraw background on resize
    };

    const drawBackground = () => {
      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    };

    const drawGasClouds = () => {
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const gradient = ctx.createRadialGradient(
        centerX,
        centerY,
        10,
        centerX,
        centerY,
        canvas.width / 2
      );
      gradient.addColorStop(0, "rgba(0, 255, 0, 0.3)");
      gradient.addColorStop(0.5, "rgba(0, 128, 0, 0.2)");
      gradient.addColorStop(1, "rgba(0, 0, 0, 0)");
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(centerX, centerY, canvas.width / 2, 0, Math.PI * 2);
      ctx.fill();
    };

    const drawStar = (time) => {
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const glowIntensity = Math.sin(time * 0.02) * 0.5 + 0.5;

      const gradient = ctx.createRadialGradient(
        centerX,
        centerY,
        0,
        centerX,
        centerY,
        canvas.width / 10
      );
      gradient.addColorStop(0, `rgba(0, 255, 0, ${0.8 * glowIntensity})`);
      gradient.addColorStop(1, `rgba(0, 128, 0, 0)`);
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(centerX, centerY, canvas.width / 10, 0, Math.PI * 2);
      ctx.fill();
    };

    const drawWaves = (time, shadowIntensity) => {
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;

      const frequencyMultiplier = Math.max(shadowIntensity / 100, 1); // Adjust frequency based on shadow intensity

      for (let i = 0; i < 4; i++) {
        const radius =
          (time * 0.15 * frequencyMultiplier + i * (canvas.width / 4)) %
          canvas.width;
        const alpha = 1 - radius / canvas.width;

        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(0, 255, 0, ${alpha})`;
        ctx.lineWidth = canvas.width / 50;
        ctx.stroke();
      }
    };

    const animate = () => {
      let time = 0;

      const loop = () => {
        time += 1;

        drawBackground();
        drawGasClouds();
        drawStar(time);

        // Handle boxShadow extraction for Safari compatibility
        const videoContainer = document.querySelector(".video-container");
        let shadowIntensity = 0;

        if (videoContainer && videoContainer.style.boxShadow) {
          const shadowMatch = videoContainer.style.boxShadow.match(/\d+/);
          if (shadowMatch) {
            shadowIntensity = parseFloat(shadowMatch[0]);
          }
        }

        drawWaves(time, shadowIntensity);
        requestAnimationFrame(loop);
      };

      loop();
    };

    resizeCanvas();
    animate();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return <canvas ref={canvasRef} className="star-formation"></canvas>;
};
